var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.rootClasses},_vm._l((_vm.listItems),function(listItem){return _c('li',{key:listItem.id,class:_vm.allItemClasses},[_vm._t("default",null,{"item":listItem})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }